import RefreshIcon from "assets/icons/RefreshIcon";
import BasicButton from "components/BasicInputs/BasicButton";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import BasicSelect from "components/BasicInputs/BasicSelect";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { DateToString } from "components/Reports/DateFilter";
import { useFormikContext } from "formik";
import useCurrency from "helpers/useCurrency";
// @ts-ignore
import Num2persian from "num2persian";
const moment = require("moment-jalaali");
// const Num2persian = require("num2persian");

export default function CreateInstallmentsRows() {
  const { shortCurrencies, defCur } = useCurrency();
  const data = useFormikContext<InstallmentData>();

  function calculateInstallments() {
    const v = data.values;
    const { installmentsCount, installmentsGap, totalPrice } = v;
    if (!installmentsCount || !installmentsGap || !totalPrice) return;
    const prePay = v.prePayType === "currency" ? v.prePay || 0 : totalPrice * ((v.prePay || 0) / 100);
    const profit = v.totalProfit || 0;
    let price = (profit + totalPrice - prePay) / installmentsCount;
    const penalty =
      v.penaltyRateType === "currency" ? v.penaltyRate || 0 : price * ((v.penaltyRate || 0) / 100);

    const d = data.values.installmentsFirstRepayDate || DateToString(new Date(Date.now()));
    let gap = 0;
    const installments = Array.from(Array(installmentsCount).keys()).map((index) => {
      const g = gap;
      const type = data.values.installmentsGapType || "month";
      const types = { day: "day", month: "jMonth", year: "jYear" };
      const m = moment(d, "jYYYY/jM/jD");
      const date = m.add(g, types[type]).format("jYYYY/jM/jD");
      gap = (data.values.installmentsGap || 0) + gap;
      const s = ["اول", "دوم", "سوم"];
      let suffix = s[index] || Num2persian(index + 1) + "م";

      return {
        id: index,
        title: `قسط ${suffix}`,
        price,
        date,
      };
    });
    data.setFieldValue("installmentRows", installments);
  }

  function addDate() {}

  return (
    <div className="relative p-6 pb-8 rounded-md ">
      <div className="pb-6 mb-6">
        <span className="text-lg text-dark-3 font-IRANSansMedium ">ایجاد اقساط</span>
      </div>
      <div className="flex flex-wrap items-start justify-between gap-4 ">
        <div className="flex flex-col gap-6">
          <div className="w-48">
            <BasicTextInput
              type="number"
              label="تعداد اقساط"
              required
              val={data.values.installmentsCount}
              onChange={(val) => data.setFieldValue("installmentsCount", val)}
            />
          </div>
          <div className="w-48">
            <BasicTextInput
              type="number-native"
              label="فاصله اقساط"
              required
              style={{ padding: "0px 12px 0px 0px" }}
              val={data.values.installmentsGap}
              onChange={(val) => data.setFieldValue("installmentsGap", val)}
              prefix={
                <div className="w-24 my-2 border-r border-gray-200">
                  <BasicSelect
                    containerStyle={{ minWidth: 60 }}
                    menuStyle={{ minWidth: 60 }}
                    btnStyle={{ border: "none", minWidth: 60 }}
                    defaultValue={data.values.installmentsGapType || "month"}
                    onChange={(val) => data.setFieldValue("installmentsGapType", val)}
                    options={[
                      { label: "روز", value: "day" },
                      { label: "ماه", value: "month" },
                      { label: "سال", value: "year" },
                    ]}
                  />
                </div>
              }
            />
          </div>
        </div>
        <div className="flex flex-col gap-6">
          <div className="w-80">
            <BasicTextInput
              type="price"
              label="مبلغ پرداختی"
              required
              style={{ padding: "0px 12px 0px 0px" }}
              val={data.values.totalPrice}
              onChange={(val) => data.setFieldValue("totalPrice", val)}
              disabled={data.values?.type === "factor" ? true : false}
              prefix={
                <div className="w-24 my-2 border-r border-gray-200">
                  <BasicSelect
                    options={shortCurrencies}
                    defaultValue={data.values.currency?.value || defCur.value}
                    onChange={(_, option) => data.setFieldValue("currency", option)}
                    btnStyle={{
                      border: "none",
                      minWidth: 80,
                    }}
                    containerStyle={{ minWidth: 80 }}
                    menuStyle={{ minWidth: 80 }}
                  />
                </div>
              }
            />
          </div>
          <div className="w-80">
            <BasicDateInput
              label="تاریخ اولین بازپرداخت"
              withoutClear
              defaultValues={[data.values.installmentsFirstRepayDate || DateToString(new Date(Date.now()))]}
              onChange={(dates) =>
                !!dates && !!dates[0] && data.setFieldValue("installmentsFirstRepayDate", dates[0])
              }
            />
          </div>
        </div>
      </div>
      <div className="absolute -translate-x-1/2 -bottom-5 left-1/2"></div>
    </div>
  );
}
